import React from "react";
import Scheduler from "../../components/scheduler/Scheduler";

const HomePage = () => {
  
  return (
    <>
    
    <div className="row mb-3">
      <Scheduler />
    </div>
    </>
    
  );
};

export default HomePage;
